<template>
  <div class="home_page">
    <Header @open="openFormModal" />

    <Info />

    <Categories
      :search="search"
      :categories-list="categoriesList"
      :courses-list="coursesList"
      @change="changeSwiper"
      @open="openCourseInfo"
      :ie="false"
      :is-loading="isLoading"
    />

    <Offer @open="openFormModal" />

    <Feed :feeds-list="feedsList" />

    <Partners :ie="false" />

    <b-modal :active.sync="isFormShow" has-modal-card scroll="keep">
      <CreateForm @submit="submitForm" @close-modal="closeFormModal" :form="newForm" />
    </b-modal>
  </div>
</template>

<script>
import Swiper from 'swiper'
import CreateForm from '@/components/modal/CreateForm'
import Header from '@/components/home/Header'
import Info from '@/components/home/Info'
import Categories from '@/components/home/Categories'
import Offer from '@/components/home/Offer'
import Feed from '@/components/home/Feed'
import Partners from '@/components/home/Partners'
import { toastInfo } from '@/lib/toastCfg'

export default {
  name: 'home',
  components: {
    CreateForm,
    Header,
    Info,
    Categories,
    Offer,
    Feed,
    Partners
  },
  data() {
    return {
      isLoading: false,
      isFormShow: false,
      newForm: this.defaultForm(),
      categoriesSwiper: {},
      headerSwiper: '',
      feedSwiper: '',
      partnersSwiper: '',
      search: {
        category: 0
      },
      feedsList: [
        'ЦРпН выручает. Удобно проходить курсы с телефона. Если что-то забыл, то информация всегда под рукой, можно зайти и посмотреть. Еще удобно готовиться к тестам.',
        'Я поддерживаю идею о том, что учиться надо всегда и везде. Нравится, что не нужно никуда ехать, чтобы прослушать лекцию или пройти очередной тест. Открыл ноутбук, вошел в свой личный кабинет, прошел тест. Спасибо за возможность заниматься из дома.',
        'Видеоматериалы, фото и презентации в онлайн-курсе отлично заменили скучные лекции в колледже. Удобно, что есть система напоминаний и оповещений. Радуют нестандартные тесты. Желаю развивать это направление и дальше.'
      ]
    }
  },
  computed: {
    coursesList() {
      return this.categoriesList[this.search.category].courses
    },
    currentCategory() {
      return this.categoriesList[this.search.category]
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  mounted() {
    // this.createHeaderSwiper()
    this.createCategoriesSwiper()
    this.createFeedSwiper()
    this.createPartnersSwiper()
  },
  methods: {
    loadCourses(categoryIindex, page = 0) {
      this.isLoading = true
      const currentCategory = this.categoriesList[categoryIindex]
      let newCourses = currentCategory.courses
      if (newCourses.length > 0 && page === 0) {
        this.isLoading = false
        return
      }
      this.$axios2
        .get('courses/list?category_id=' + currentCategory.id + '&page=' + page)
        .then((resp) => {
          this.$store.commit('setCategoryCoursesList', { list: resp.data, index: categoryIindex })
          this.isLoading = false
          this.$nextTick(() => {
            this.categoriesSwiper.update()
          })
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    defaultForm() {
      return {
        name: '',
        phone: '',
        comment: '',
        region: ''
      }
    },
    openFormModal() {
      this.isFormShow = true
      this.newForm = this.defaultForm()
    },
    closeFormModal() {
      this.isFormShow = false
    },
    submitForm() {
      this.$axios
        .post('submit-application', this.newForm)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.closeFormModal()
        })
        .catch(this.$errorToast)
    },
    openCourseInfo(courseId) {
      this.$router.push('/course-info/' + courseId)
    },
    changeSwiper() {
      this.loadCourses(this.search.category)
    },
    createHeaderSwiper() {
      this.headerSwiper = new Swiper('.header .swiper-container', {
        loop: true,
        spaceBetween: 75,
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          invert: true
        },
        navigation: {
          nextEl: '.header .swiper-button-next',
          prevEl: '.header .swiper-button-prev'
        }
      })
    },
    createCategoriesSwiper() {
      this.categoriesSwiper = new Swiper('.categories .swiper-container', {
        slidesPerView: 'auto',
        freeMode: true,
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          invert: true
        },
        navigation: {
          nextEl: '.categories .swiper-button-next',
          prevEl: '.categories .swiper-button-prev'
        },
        on: {
          slideChange: () => {
            if (this.categoriesSwiper.isEnd && this.coursesList.length < this.currentCategory.totalCourses) {
              this.loadCourses(this.search.category, Number(this.coursesList.length / 15) + 1)
            }
          }
        }
      })
    },
    createFeedSwiper() {
      this.feedSwiper = new Swiper('.feed .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.feed .swiper-pagination'
        },
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          invert: true
        },
        navigation: {
          nextEl: '.feed .swiper-button-next',
          prevEl: '.feed .swiper-button-prev'
        },
        breakpoints: {
          // when window width is >= 320px
          500: {
            slidesPerView: 1
          },
          900: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 3
          }
        }
      })
    },
    createPartnersSwiper() {
      this.partnersSwiper = new Swiper('.partners .swiper-container', {
        slidesPerView: 5,
        spaceBetween: 30,
        // autoplay: {
        //    delay: 2500,
        //    disableOnInteraction: false
        // },
        pagination: {
          el: '.partners .swiper-pagination'
        },
        freeMode: true,
        direction: 'horizontal',
        mousewheel: {
          forceToAxis: true,
          invert: true
        },
        navigation: {
          nextEl: '.partners .swiper-button-next',
          prevEl: '.partners .swiper-button-prev'
        },
        breakpoints: {
          // when window width is >= 320px
          500: {
            slidesPerView: 2
          },
          900: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 3
          }
        }
      })
    }
  }
}
</script>
